<mat-form-field
    [color]="property.isWarn ? 'warn' : 'primary'"
    attr.data-cy="filter-input-multiline-{{ property.Key }}"
    [ngClass]="errorStateMatcher?.validationClass ?? 'valid'"
    [appearance]="appearance ?? 'fill'"
>
    <mat-label *ngIf="property.displayKey">{{ property.displayKey ? property.Key : '' }}</mat-label>
    <span
        matPrefix
        *ngIf="property.prefix"
        >{{ property.prefix }}</span
    >
    <span
        matPrefix
        *ngIf="property.hasIcon"
        ><i class="{{ property.iconClass }}"></i
    ></span>
    <textarea
        matInput
        [disabled]="disabled ? disabled : null"
        rows="{{ property.rows }}"
        placeholder="{{ property.placeholder }}"
        [spellcheck]="property.spellcheck"
        [(ngModel)]="property.Value"
        (ngModelChange)="errorStateMatcher?.markAsInteracted()"
        (blur)="errorStateMatcher?.markAsInteracted()"
        (keydown)="onKeyDown($event)"
        [errorStateMatcher]="errorStateMatcher"
        id="{{ property.Key }}"
    ></textarea>
    <span
        matSuffix
        *ngIf="property.suffix"
        >{{ property.suffix }}</span
    >
    <mat-hint>{{ property.hint }}</mat-hint>
    <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
</mat-form-field>
